import { render, staticRenderFns } from "./TableBGMesurementV2.vue?vue&type=template&id=0d6ce71f&scoped=true"
import script from "./TableBGMesurementV2.vue?vue&type=script&lang=js"
export * from "./TableBGMesurementV2.vue?vue&type=script&lang=js"
import style0 from "./TableBGMesurementV2.vue?vue&type=style&index=0&id=0d6ce71f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ce71f",
  null
  
)

export default component.exports